module.exports = {
    cognitoUserPoolClientId: '44qoisltor1djbko5a7ip38gu1',
    cognitoUserPoolId: 'us-east-1_SQVAodnkw',
    environment: 'staging',
    lowerEnvironment: 'test',
    restApiEndpoint: 'https://jwsgdtxe3j.execute-api.us-east-1.amazonaws.com/staging',
    restApiName: 'staging-dsco-ship-codes-ApiStack-EKQOZYAPFACF'
}
